module.exports = __webpack_public_path__ + "static/apple-img-3b190412365d651e854a8c1900a291b8.jpeg";